import React from "react";
import AppBrand from "../components/common/AppBrand";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateAxiosHeaders } from "../api/axios_instance";

const NotFound = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const signOut = async (e) => {
    e.preventDefault();
    navigate("/");
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="login-box">
            <div className="login_logo">
              <AppBrand className="app-brand--login" />
            </div>
          </div>
        </div>
      </div>

      <div className="container" style={{ textAlign: "center" }}>
        <div className="row">
          <div className="span12">
            <div className="hero-unit center">
              <h1>
                Page Not Found{" "}
                <small style={{ fontFamily: "Tahoma", color: "red" }}>
                  Error 404
                </small>
              </h1>
              <br />
              <p>
                The page you requested could not be found please try again. Use
                your browsers <b>Back</b> button to navigate to the page you
                have prevously come from
              </p>
              <p>
                <b>Or you could just press this neat little button:</b>
              </p>
              <button
                className="btn btn-large btn-info not-found-home-btn"
                onClick={signOut}
              >
                <i className="icon-home icon-white"></i> Take Me Home
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
